<template>
  <div class="container mt-5">
    <div class="section-title">
      <h2>Dietitian Department</h2>
      <p>
        The Department of Dietetics provides expert nutritional support to
        patients across all age groups and medical conditions. Our qualified
        dietitians evaluate nutritional needs, design personalized meal plans,
        and guide patients in managing diseases through balanced diets.
      </p>
    </div>
    <div class="row">
      <div class="col-lg-4">
        <img
          src="@/assets/img/departments/Dietitian.jpg"
          alt="Dietitian Department"
          class="img-thumbnail img-thumbnail-box"
        />
      </div>
      <div class="col-lg-8">
        <p><strong>Department of Dietetics</strong></p>
        <p>
          The department plays a crucial role in supporting recovery after
          surgery, managing chronic conditions like diabetes, hypertension,
          obesity, and gastrointestinal disorders, and promoting preventive
          healthcare through nutrition.
        </p>
        <p>
          We work in close coordination with doctors and specialists to provide
          therapeutic diets for in-patients and customized counseling for
          out-patients. Our focus is on sustainable, evidence-based dietary
          practices that improve quality of life and long-term health outcomes.
        </p>
        <p>
          Nutrition awareness sessions and weight management programs are
          conducted regularly to encourage healthy eating habits in the
          community. The department stands committed to building a healthier
          society through food-based wellness.
        </p>
      </div>
    </div>
  </div>
  <DoctorsList :name="name" :queryName="queryName" :teamName="teamName" />
</template>

<script lang="ts">
import DoctorsList from '@/components/Departments/common/DoctorsListTemplate3.vue';
import { DepartmentPropDataInterface } from '@/ts/interfaces';
import { defineComponent } from 'vue';

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: 'Dietitian Experts',
      queryName: 'Dietitian',
      teamName: 'Dietitian team',
    };
  },
  components: { DoctorsList },
});
</script>

<style scoped lang="scss">
@import '@/scss/sectionTemplate2.scss';
</style>
